<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <b-card>
        <h4><i class="fas fa-chart-bar"></i> รายงานรายได้คลินิก</h4>
        <b-card no-body class="mt-1 mb-0 pb-0">
          <b-tabs class="mb-0" v-model="tabIndex" card>
            <b-tab lazy title="รายการรักษา" @click="saveTabIndex">
              <ClinicItemsIncomeReport :branch-filter.sync="branchFilter" />
            </b-tab>
            <b-tab lazy title="ใบเสร็จ" @click="saveTabIndex">
              <ClinicReceiptIncomeReport :branch-filter.sync="branchFilter" />
            </b-tab>
            <b-tab lazy title="รายได้แพทย์" @click="saveTabIndex">
              <ClinicDoctorsIncomeReport :branch-filter.sync="branchFilter" />
            </b-tab>
            <b-tab lazy title="ค่าใช้จ่ายแลป" @click="saveTabIndex">
              <ClinicLabReport :branch-filter.sync="branchFilter" />
            </b-tab>
            <!--
              Appended LAST on purpose: saveTabIndex persists clinicReportTabIndex as a raw
              integer, so inserting a tab anywhere else moves every user's saved tab.
            -->
            <b-tab lazy title="ส่วนลด" @click="saveTabIndex">
              <ClinicDiscountUsageReport :branch-filter.sync="branchFilter" />
            </b-tab>
            <b-tab lazy title="เงินมัดจำ" @click="saveTabIndex">
              <ClinicDepositReport />
            </b-tab>
          </b-tabs>
        </b-card>
      </b-card>
      <PaymentReceiptPreviewModal
        ref="paymentReceiptPreviewModal"
      ></PaymentReceiptPreviewModal>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ClinicItemsIncomeReport from "@/components/reports/ClinicItemsIncomeReport";
import ClinicReceiptIncomeReport from "@/components/reports/ClinicReceiptIncomeReport";
import ClinicDoctorsIncomeReport from "@/components/reports/ClinicDoctorsIncomeReport";
import ClinicLabReport from "@/components/reports/ClinicLabReport";
import ClinicDiscountUsageReport from "@/components/reports/ClinicDiscountUsageReport";
import ClinicDepositReport from "@/components/reports/ClinicDepositReport";

import PaymentReceiptPreviewModal from "@/components/modal/PaymentReceiptPreviewModal";

import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import moment from "moment";
import { eventBus } from "../main";

export default {
  name: "ClinicIncomeReport",
  components: {
    ClinicItemsIncomeReport,
    ClinicReceiptIncomeReport,
    ClinicDoctorsIncomeReport,
    ClinicLabReport,
    ClinicDiscountUsageReport,
    ClinicDepositReport,
    Dialog,
    Loading,
    PaymentReceiptPreviewModal,
  },
  data() {
    return {
      isLoading: false,
      tabIndex: null,
      // สาขา picked on one tab carries over to the others (matched by branch name).
      branchFilter: [],
    };
  },
  computed: {
    ...mapGetters({
      isManager: "moduleUser/isManager",
    }),
  },
  methods: {
    ...mapActions({
      fetchPatientById: "modulePatient/fetchPatientById",
      fetchReceiptById: "moduleReceipt/fetchReceiptById",
    }),
    moment() {
      return moment();
    },
    saveTabIndex() {
      this.$nextTick(() => {
        localStorage.setItem("clinicReportTabIndex", this.tabIndex);
      });
    },
    openReceiptModal(data) {
      const receiptPromise = this.fetchReceiptById({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: data.branchUrl || this.$route.params.branchUrl,
        id: data.id,
      });
      const patientPromise = this.fetchPatientById({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: data.branchUrl || this.$route.params.branchUrl,
        id: data.patientId,
      });

      this.isLoading = true;
      Promise.all([receiptPromise, patientPromise])
        .then(responseAll => {
          if (responseAll) {
            const [receiptRes, patientRes] = responseAll;
            if (receiptRes.status == 200 && patientRes.status == 200) {
              if (receiptRes.data.id && patientRes.data.id) {
                this.$refs.paymentReceiptPreviewModal.show(
                  receiptRes.data,
                  patientRes.data,
                  receiptRes.data.cancel ? "cancel" : "copy",
                  this.isManager
                );
              } else {
                eventBus.$emit("alertSwal", {
                  title: "ระบบขัดข้อง",
                  message: "ไม่สามารถแสดงข้อมูลใบเสร็จได้",
                  icon: "error",
                });
              }
            }
          }
        })
        .catch(err => {
          console.error("catch:", err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tabIndex = parseInt(localStorage.getItem("clinicReportTabIndex"));
    });
    eventBus.$on("openReceipt", e => {
      this.openReceiptModal(e);
    });
  },
};
</script>

<style scoped></style>
